import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

import { AppConfiguration, windowWithPrivaConfig } from './app-configuration.model';

export type ApiCategory = 'control' | 'equipment' | 'asd';

@Injectable({
    providedIn: 'root',
})
export class AppConfigurationService {
    private config!: AppConfiguration;
    private configurationLoadedSubject = new ReplaySubject<boolean>(1);

    constructor() {
        this.loadConfiguration();
    }

    get configuration(): AppConfiguration {
        if (!this.config) {
            this.config = windowWithPrivaConfig.privaConfig;
        }
        return this.config;
    }

    loadConfiguration(): void {
        if (!this.config) {
            this.config = windowWithPrivaConfig.privaConfig;
        }

        this.configurationLoadedSubject.next(!!this.config);
    }

    getBaseUrl(apiCategory: ApiCategory): string {
        switch (apiCategory) {
            case 'control':
                return this.config.uris.masterDataControlServices;
            case 'equipment':
                return this.config.uris.masterDataEquipmentServices;
            case 'asd':
                return this.config.uris.asdProcessorServices;
            default:
                throw new Error('API category out of range');
        }
    }

    get configurationLoaded(): Observable<boolean> {
        return this.configurationLoadedSubject.asObservable();
    }
}
